/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router';

import { refreshSession, logout } from 'data/actions/session';
import { getRefreshFailed, getRefreshLoading, getSessionActive } from 'data/selectors/session';
import { clear } from 'data/actions/api';
import { getUnauthorized, getAccountLocked, getBackendError } from 'data/selectors/api';

const mapStateToProps = (state) => ({
  refreshFailed: getRefreshFailed(state),
  refreshLoading: getRefreshLoading(state),
  unauthorized: getUnauthorized(state),
  backendError: getBackendError(state),
  accountLocked: getAccountLocked(state),
  sessionIsActive: getSessionActive(state),
});

const mapDispatchToProps = {
  refreshSession,
  logout,
  clear,
};

class ApiInterceptorClass extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    refreshSession: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    refreshFailed: PropTypes.bool,
    refreshLoading: PropTypes.bool,
    unauthorized: PropTypes.bool.isRequired,
    navigate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    placeholder: PropTypes.node,
    clear: PropTypes.func.isRequired,
    backendError: PropTypes.string,
    accountLocked: PropTypes.bool.isRequired,
    sessionIsActive: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    refreshFailed: false,
    refreshLoading: false,
    placeholder: null,
    backendError: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.refreshFailed) {
      this.props.logout();
    } else if (this.props.unauthorized && !prevProps.unauthorized) {
      this.props.refreshSession();
    } else if (this.props.backendError) {
      this.props.navigate(this.getPrefixedPath(this.props.backendError), { replace: true });
      this.props.clear();
    }
  }

  getPrefixedPath = (path) => {
    if (this.props.accountLocked) return '/too-many-requests';

    if (this.props.sessionIsActive) {
      const prefix = this.props.location.pathname.includes('admin') ? '/admin' : '/app';
      return prefix.concat('/', path);
    }
    return path;
  };

  render() {
    return this.props.refreshLoading ? this.props.placeholder : this.props.children;
  }
}

const ConnectedApiInterceptor = connect(mapStateToProps, mapDispatchToProps)(ApiInterceptorClass);

// Wrapper to provide navigate and location from hooks
function ApiInterceptor({ children, ...props }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <ConnectedApiInterceptor navigate={navigate} location={location} {...props}>
      {children}
    </ConnectedApiInterceptor>
  );
}

ApiInterceptor.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ApiInterceptor;
